export const outlineButton = 'text-gray-500 bg-transparent border border-solid border-gray-500 hover:bg-gray-500 hover:text-white active:bg-gray-600 font-bold uppercase px-8 py-3 rounded-full outline-none focus:outline-none mr-1 mb-1';


export const fillButton = 'text-white bg-green-400 hover:bg-gray-600 hover:text-white active:bg-gray-600 font-bold uppercase px-8 py-3 rounded-full outline-none focus:outline-none mr-1 mb-1';

export const defaultTransiton = { transition: "all .15s ease" };

export const textAreaDefaultProps = { 
    required:true,
    rowsMax:10, 
    rowsMin:10,
    maxLength:1000,
};
